module.exports = __webpack_public_path__ + "static/media/8.3ac9936c.jpg";